import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslations from "./i18n/en.json";
import hrTranslations from "./i18n/hr.json";

const resources = {
  en: {
    translation: enTranslations,
  },
  hr: {
    translation: hrTranslations,
  },
};

const savedLanguage = localStorage.getItem("language") || "en";

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage, // default language
  fallbackLng: "en", // fallback language
  interpolation: {
    escapeValue: false, // react already does escaping
  },
});

export default i18n;
